import { Store } from "../../__generated__/graphql";
import NoProduct from "./no-product";
import ProductCard from "../product/product-card";

interface TimeSaleSectionProps {
  store: Store;
  timeLeft: string;
  onClickProduct: (
    product: {
      id: number;
      name: string;
      userPrice: number;
      price: number;
    },
    isAddToCart?: boolean
  ) => void;
  onClickLike: (
    storeId: number,
    isLiked: boolean | null,
    storeTitle?: string
  ) => Promise<void>;
  bestReviewId?: number | null;
  cart: Array<{ product: { id: number }; quantity: number }>;
}

const TimeSaleSection = ({
  store,
  timeLeft,
  onClickProduct,
  onClickLike,
  bestReviewId,
  cart,
}: TimeSaleSectionProps) => (
  <div>
    {store?.todaysProducts?.length === 0 ? (
      <NoProduct
        storeId={store.id}
        storeTitle={store?.title}
        reviewImg={store?.reviewImg}
        reviewContent={store?.reviewContent}
        onClickLike={onClickLike}
        isLiked={store?.isLiked}
      />
    ) : (
      <>
        <div className="w-full px-5 pb-10 h-full relative flex flex-col bg-white">
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-4 bg-[#F8F9FA] rounded-xl px-4 py-3 w-full">
              <span className="text-gray-500 text-sm">
                픽업 가능 시간{" "}
                <span className="text-gray-800 font-medium ml-1">
                  ~ {store?.closingHours}
                </span>
              </span>
            </div>
          </div>

          {/* 매장안내 */}
          {store?.liveOrderNotice && (
            <div className="mb-4 w-full bg-gray-50 rounded-xl px-4 py-3">
              <div className="mb-1">
                <span className="text-gray-800 font-bold text-sm">
                  📢 매장안내
                </span>
              </div>
              <p className="text-gray-600 text-sm whitespace-pre-wrap leading-relaxed">
                {store.liveOrderNotice}
              </p>
            </div>
          )}

          <div className="flex flex-col gap-y-4">
            {store?.todaysProducts
              ?.filter(
                (product) =>
                  product.isDeleted === false || product.isDeleted === null
              )
              .map((product) => (
                <ProductCard
                  key={product.id}
                  product={product}
                  onClickProduct={onClickProduct}
                  cartQuantity={
                    cart.find((item) => item.product.id === product.id)
                      ?.quantity || 0
                  }
                />
              ))}
          </div>
        </div>
      </>
    )}
  </div>
);
export default TimeSaleSection;
